export default "__VITE_ASSET__C_v$_xLH__"